export const WEEKDAY_LABELS = ['일', '월', '화', '수', '목', '금', '토'];

export const SLOT_START_HOUR = 9;
export const SLOT_COUNT = 30;

export function weekStartOf(date) {
  const day = date.day(); // 0=일 ~ 6=토
  const diff = (day - 3 + 7) % 7; // 3=수요일
  return date.subtract(diff, 'day').startOf('day');
}

export function weekDays(weekStartDate) {
  return Array.from({ length: 7 }, (_, i) => weekStartDate.add(i, 'day'));
}

export function allSlotTimes() {
  return Array.from({ length: SLOT_COUNT }, (_, i) => {
    const totalMinutes = SLOT_START_HOUR * 60 + i * 30;
    const hour = Math.floor(totalMinutes / 60);
    const minute = totalMinutes % 60;
    return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
  });
}

export function formatDateKey(date) {
  return date.format('YYYY-MM-DD');
}

export function slotKey(dateStr, timeStr) {
  return `${dateStr}|${timeStr.slice(0, 5)}`;
}

export function formatDayLabel(date) {
  return `${date.format('MM/DD')}(${WEEKDAY_LABELS[date.day()]})`;
}
